{
  "version": 1,
  "asset_id": "62b6b84f-6c20-42aa-8af6-89a95911d5ef",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/62b6b84f-6c20-42aa-8af6-89a95911d5ef/dilated-pouch-boxed-en-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/62b6b84f-6c20-42aa-8af6-89a95911d5ef/dilated-pouch-boxed-en-800.webp",
  "original_filename": "dilated-pouch-boxed-en-800.webp",
  "size": 36058,
  "content_type": "image/webp",
  "created_at": "2026-10-06T14:27:42Z"
}
